/**
 * Format a catchment radius for map/panel display:
 * up to 2 decimal places, trailing zeros stripped (6.70 → "6.7", 6.55 → "6.55", 10 → "10").
 */
export function formatRadiusDistance(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return value == null || value === "" ? "—" : String(value);
  return n.toFixed(2).replace(/\.?0+$/, "");
}
